<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="true"
                :showAddNew="true"
                :title="'Patient Reg > Medicine Order'"
                btnTitle="New Bill"
                :showExtraField="true"
                :extraFieldData="'Patient, Age, Gender'"
                @onClickCloseButton="closeButton"
            />
        </div>

        <div class="p-2">
            <DateQuerySetter
                btnTitle="Go"
                :isVisible="true"
            >
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <label for="colFormLabel" class="col-form-label">Select Doctor: </label>
                    <v-select 
                        placeholder="Select Unit"
                    />
                </div>
            </DateQuerySetter>
        </div>

        <div class="col-12 px-2 mt-2">
            <ListTable :tableItems="tableItems"/>
        </div>
    </div>
</template>

<script setup>
    import TitleButton from '@/components/atom/TitleButtonHospital';
    import DateQuerySetter from '@/components/atom/DateQuerySetter';
    import ListTable from '@/components/molecule/company/hospital/MedicineListTable.vue';
    import {useRoute, useRouter} from "vue-router";

    const $route = useRoute();
    const $router = useRouter();
    const tableItems = [{date: '11 Jan 2023 10 AM', consultantName: 'aavc', orderNo: 5, admissionNo: 5, unit: 10, completeDate: '11 Jan 2023 10 AM'}];
    
    const closeButton = () => {
        $router.back();
    }
</script>